import { Location } from '@angular/common';
import { ApplicationRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';

import { AlertController, toDataURL, ZoomServiceController } from 'mm-ui';

import { fadeAnimation, fadeOpacity } from 'projects/f-cms/src/app/animations/animations';
import { AppComponent } from 'projects/f-cms/src/app/app.component';
import { LoggedUser } from 'projects/f-cms/src/app/models/loggedUser.service';
import { Media } from 'projects/f-cms/src/app/models/Media';
import { MenuWorkflowService } from '../../../workflow/menu-workflow/menu-workflow.service';
import { ContentService } from '../content.service';
import { CreatePageService } from '../create-page/create-page.service';
import { NotifyService } from '../../../../services/notify.service';
import { TranslateService } from '@ngx-translate/core';
import { MediaService } from '../../../media/media.service';

@Component({
  selector: 'fab-page-homepages',
  templateUrl: './fab-page-homepages.component.html',
  styleUrls: ['./fab-page-homepages.component.scss']
})
export class FabPageHomepagesComponent implements OnInit {

  @Input('homepageId') homepageId: string;
  @Input('pageId') pageId: string;
  @Input('menuId') menuId: string;
  @Input('parentId') parentId: string;
  @Input('media') media: Media;
  @Input('pageView') pageView: boolean = false;
  @Input('type') type: string;
  @Input('userRole') userRole: boolean | string;
  @Input('userCanWrite') userCanWrite: boolean;
  @Input('importation') public importation: boolean;
  @Output('savePage') savePage = new EventEmitter();
  @Output('preview') previewEmiter = new EventEmitter();
  @Output('deleteEmitter') deleteEmitter = new EventEmitter()

  show: boolean = true;
  hasPermission: boolean;
  permissionType: string;
  permission: boolean;

  iTk: any;

  constructor(
    private _router: Router,
    private contentService: ContentService,
    private pageService: CreatePageService,
    private notifyService: NotifyService,
    private appRef: ApplicationRef,
    private MenuWorkService: MenuWorkflowService,
    private user: LoggedUser,
    private location: Location,
    private alert: AlertController,
    private route: ActivatedRoute,
    private messageService: MessageService,
    private _translate: TranslateService,
    private _mediaService: MediaService,
    private zoomService: ZoomServiceController) {
    let appref = this.appRef.components[0].instance as AppComponent
    this.alert.setViewContainerRef(appref.vcr)
  }

  ngOnInit() {

    this._mediaService.getIamToken().subscribe(itk => this.iTk = itk);

    this.getUserPermission()
    this.validatePermissionType()
    console.log('userRole', this.userRole)
  }

  validatePermissionType() {
    if (this.pageId) {
      this.permissionType = 'page';
    } else if (this.homepageId) {
      this.permissionType = 'homepage'
    } else if (this.media) {
      this.permissionType = 'media'
    }
  }

  getUserPermission() {
    console.log('getUserPermission', this.user.checkRole('CI'))
    this.hasPermission = this.user.checkRole('CI')
    console.log('hasPermission', this.hasPermission)
  }

  preview() {
    this.previewEmiter.emit(true);
  }

  gotoPage() {
    this.pageId && window.open(`/hp/page/${this.parentId}`)
  }

  openWorkflowMenu() {
    this.MenuWorkService.openMenu()
  }

  closeWorkflowMenu() {
    this.MenuWorkService.closeMenu()
  }

  showMedia() {
    let appref = this.appRef.components[0].instance as AppComponent
    this.zoomService.setViewContainerRef(appref.vcr)

    if (this.media) {
      this.zoomService.configureMedia(this.media);

      if (this.media.content_type.includes('image')) {
        this.zoomService.configure(this.media.url_download, this.iTk)
      }
    }

    this.zoomService.open()
  }

  downloadMedia() {
    this._mediaService.downloadMedia(this.media.url_download, this.media.filename);
  }

  addPage() {
    if (this.pageId) {
      this._router.navigate(['cms', 'content', 'page', this.homepageId, this.pageId])
    } else {
      this._router.navigate(['cms', 'content', 'page', this.homepageId])
    }
  }

  delete() {
    if (this.type == 'notify') {
      let id = this.route.snapshot.params.id;
      this.alertPopup('notify', this._translate.instant('button.email.remove'), this._translate.instant('cms.content.menu.removeNotify'), this._translate.instant('cms.content.menu.wantRemoveNotify'), this.notifyService.deleteNotify(id))

    } else {
      if (!this.pageId) {
        this.alertPopup('homepage', this._translate.instant('button.email.remove'), this._translate.instant('cms.content.menu.removeHome'), this._translate.instant('cms.content.menu.wantRemoveHome'), this.contentService.deleteHomepage(this.homepageId))
      } else {

        if (this.importation == true) {
          this.alertPopup('page', this._translate.instant('button.email.remove'), this._translate.instant('cms.content.menu.removePage'), this._translate.instant('cms.content.menu.wantRemovePage'), this.pageService.deleteImportationPage(this.parentId))
        } else {
          this.pageService.hasImportations(this.pageId)
            .subscribe(resp => {
              if (resp.hasImportation) {
                this.alertPopup('page', this._translate.instant('button.email.remove'), this._translate.instant('cms.content.menu.removePage'), this._translate.instant('cms.content.menu.removedeletingItWillPage'), this.pageService.deletePage(this.menuId, this.pageId, { removeImportations: true }))
              } else {

                this.alertPopup('page', this._translate.instant('button.email.remove'), this._translate.instant('cms.content.menu.removePage'), this._translate.instant('cms.content.menu.wantRemovePage'), this.pageService.deletePage(this.menuId, this.pageId, {}))
              }
            })
        }

      }
    }
  }

  alertPopup(type, title, text, message, endpoint) {
    const config = {
      showSelectTag: false,
      width: '30%',
      top: '200px',
      height: '0px',
      left: '0',
      title: title,
      buttonCenter: true,
      message: message,
      buttons: [
        {
          text: this._translate.instant('button.cancel'),
          type: 'outline-dark',
          handler: () => { }
        },
        {
          text: text,
          type: 'primary',
          handler: () => {
            endpoint.subscribe(
              () => this.successDeleted(type),
              err => { console.log(err); this.cantDelete(type) }
            )
          }
        }
      ]
    }
    this.alert.configure(config);
    this.alert.open();
  }

  cantDelete(arg0): void {

    if (arg0 == 'page') {
      this.messageService.add({ severity: 'error', summary: this._translate.instant('cms.content.menu.deleteErrorPage'), detail: this._translate.instant('cms.content.menu.') });
    } else if (arg0 == 'notify') {
      this.messageService.add({ severity: 'error', summary: this._translate.instant('cms.content.menu.deleteErrorNotify'), detail: this._translate.instant('cms.content.menu.') });
    } else {
      this.messageService.add({ severity: 'error', summary: this._translate.instant('cms.content.menu.deleteErrorHome'), detail: this._translate.instant('cms.content.menu.') });
    }

  }

  successDeleted(arg0: string): void {


    if (arg0 == 'page') {
      this.messageService.add({ severity: 'success', summary: this._translate.instant('cms.content.menu.deleteSuccessPage'), detail: this._translate.instant('cms.content.menu.deleteSuccess') });
    }
    else if (arg0 == 'notify') {
      this.messageService.add({ severity: 'success', summary: this._translate.instant('cms.content.menu.deleteSuccessNotify2'), detail: this._translate.instant('cms.content.menu.deleteSuccess3') });
    }
    else {
      this.messageService.add({ severity: 'success', summary: this._translate.instant('cms.content.menu.deleteSuccessHome'), detail: this._translate.instant('cms.content.menu.deleteSuccess') });
    }

  }

  convertBase64ToBlob(base64Image: string) {
    const parts = base64Image.split(';base64,');
    const imageType = parts[0].split(':')[1];
    const decodedData = window.atob(parts[1]);
    // so deus sabe pq tava quebrando quando baixa esse mimetype
    const uInt8Array = new Uint8Array(imageType === 'application/vnd.ms-excel.sheet.macroenabled.12' ? decodedData.length - 1 : decodedData.length);

    for (let i = 0; i < decodedData.length; ++i) {
      uInt8Array[i] = decodedData.charCodeAt(i);
    }

    return new Blob([uInt8Array], { type: imageType });
  }

  openMedia(url, iTk, name) {

    this._mediaService.getCDNImage(url, iTk).subscribe((binarie: any) => {

      let file = toDataURL(binarie)
      if (file) {

        file.then((data: any) => {

          const blob = this.convertBase64ToBlob(data.result);
          const blobUrl = URL.createObjectURL(blob);
          // window.open(blobUrl, '_blank');

          //let url = window.URL.createObjectURL(data);
          let a = document.createElement('a');
          document.body.appendChild(a);
          a.setAttribute('style', 'display: none');
          a.href = blobUrl;
          a.download = name;
          a.click();
          window.URL.revokeObjectURL(url);
          a.remove();

        })
      }
    })
  }

}
